/**
 * Appends next collection page products via Section Rendering API.
 * Delegated clicks survive facet AJAX replacement of the product grid.
 */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-collection-load-more]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var nextUrl = btn.getAttribute('data-next-url');
    var sectionId = btn.getAttribute('data-section-id');
    if (!nextUrl || !sectionId) return;

    var root = document.getElementById('collection-load-more-root');
    var grid = document.getElementById('product-grid');
    if (!grid || !root) return;

    var label = btn.querySelector('.collection-load-more__label');
    var btnSpinner = btn.querySelector('.collection-load-more__button-spinner');

    function setButtonLoading(loading) {
      btn.setAttribute('aria-busy', loading ? 'true' : 'false');
      btn.classList.toggle('collection-load-more__button--loading', loading);
      if (label) label.classList.toggle('hidden', loading);
      if (btnSpinner) btnSpinner.classList.toggle('hidden', !loading);
    }

    btn.disabled = true;
    setButtonLoading(true);

    var fetchUrl;
    try {
      fetchUrl = new URL(nextUrl, window.location.origin);
      fetchUrl.searchParams.set('section_id', sectionId);
    } catch (err) {
      console.error('collection-load-more: invalid next URL', err);
      btn.disabled = false;
      setButtonLoading(false);
      return;
    }

    fetch(fetchUrl.toString())
      .then(function (res) {
        if (!res.ok) throw new Error(res.statusText || String(res.status));
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.getElementById('product-grid');
        if (!nextGrid) {
          console.warn('collection-load-more: missing #product-grid in response');
          throw new Error('Missing product grid');
        }

        var nextItems = nextGrid.querySelectorAll(':scope > li.grid__item');
        var holder = document.createElement('div');
        nextItems.forEach(function (li) {
          holder.appendChild(li.cloneNode(true));
        });

        if (typeof initializeScrollAnimationTrigger === 'function') {
          initializeScrollAnimationTrigger(holder);
        }

        while (holder.firstChild) {
          grid.appendChild(holder.firstChild);
        }

        holder = null;

        var nextRoot = doc.getElementById('collection-load-more-root');
        var liveRoot = document.getElementById('collection-load-more-root');
        if (liveRoot) {
          if (nextRoot) {
            liveRoot.innerHTML = nextRoot.innerHTML;
            if (!liveRoot.querySelector('[data-collection-load-more]')) {
              liveRoot.remove();
            }
          } else {
            liveRoot.remove();
          }
        }
      })
      .catch(function (err) {
        console.error('collection-load-more', err);
        btn.disabled = false;
        setButtonLoading(false);
      });
  });
})();
